import { useEffect } from "react";
import { CircleNotch } from "@phosphor-icons/react";
import { ThemeProvider } from "./providers/ThemeProvider";
import { AppRouter } from "./Router";
import { ToastProvider } from "../components/ui/Toast";

import { ErrorBoundary } from "../components/ErrorBoundary";
import { useAuthStore } from "../stores/auth";
import { APP_NAME } from "../lib/brand";

function AuthGate({ children }: { children: React.ReactNode }) {
  const { initialized, initialize } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-primary)]">
        <CircleNotch size={20} weight="bold" className="animate-spin text-[var(--text-muted)]" />
      </div>
    );
  }

  return <>{children}</>;
}

export function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary fallbackMessage={`${APP_NAME} encountered an unexpected error.`}>
        <AuthGate>
          <AppRouter />
        </AuthGate>
      </ErrorBoundary>
      <ToastProvider />
    </ThemeProvider>
  );
}
